import { Overrides } from '@material-ui/core/styles/overrides';

export const initializeAccordionDetailsOverrides = (
  config?: Overrides['MuiAccordionDetails']
): Overrides['MuiAccordionDetails'] => {
  return {
    root: {},
    ...config,
  };
};
